function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.816 7.217a.408.408 0 01-.15-.45l.067-.209a.408.408 0 01.367-.291l5.325-.425L8.466.933a.425.425 0 01.425-.266h.217A.408.408 0 019.5.933l2.05 4.909 5.325.425c.171.01.318.127.366.291l.067.209a.408.408 0 01-.125.45l-4.017 3.45 1.234 5.175a.425.425 0 01-.159.441l-.241.134a.417.417 0 01-.467 0L9 13.667l-4.56 2.775a.417.417 0 01-.466 0l-.184-.125a.425.425 0 01-.158-.442l1.2-5.208-4.017-3.45z",
  fill: "#EBCA62"
});

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 1,
    viewBox: "0 0 18 17",
    fill: "none"
  }, props), _ref);
};

export default SvgStar;